// Lists tab: the user's plant lists (lazy-loaded by the controller). Guests get
// a sign-in nudge instead of a silent placeholder (v1 parity).

import { esc, plantRowInner, PLACE_HINT } from './html';

export function listsPanelHtml({ username, loading, lists }) {
  const title = '<h3 class="pl2-section-title">Your lists</h3>';
  if (!username) return `${title}<p class="pl2-muted"><a href="/users/sign_in">Log in</a> to see your plant lists here.</p>`;
  if (loading) return `${title}<p class="pl2-muted">Loading…</p>`;
  const entries = Object.entries(lists || {});
  if (!entries.length) return `${title}<p class="pl2-muted">No lists yet.</p>`;
  return title + entries.map(([id, list]) => `
    <details class="pl2-list">
      <summary>${esc(list.name)} <span class="pl2-muted">(${(list.plants || []).length})</span></summary>
      ${(list.plants || []).map((p, i) => `
        <div class="pl2-result" data-pl2="list-place" data-list="${esc(id)}" data-idx="${i}" data-species-info="list:${esc(id)}:${i}" data-species-hint="${PLACE_HINT}">
          ${plantRowInner(p)}
        </div>`).join('')}
    </details>`).join('');
}
